'use strict';

import Component from '_core_ext/components/Component';
import eventMgr from '_core_ext/eventMgr';

const emitter = eventMgr.getEmitter('cartitembeforedelete');

export default class DeletePopup extends Component {
    init() {
        super.init();
        this.event('click', '.js-delete-yes', this.confirmPopup);
        this.event('click', '.js-delete-no', this.dismissPopup);
        this.action = this.$el.find('.js-item-action').val();
    }

    confirmPopup() {
        emitter.emit('deleteconfirmed', this.action);
    }

    dismissPopup() {
        emitter.emit('deletedismissed');
    }
}
